<template>
  <v-progress-circular :size="70" :width="2" color="primary" indeterminate></v-progress-circular>
</template>

<script>
export default {
  name: 'Loader'
}
</script>
